<template>
  <div class="flex h-full w-full rounded-lg overflow-hidden">
    <Editor class="grow w-full basis-full"
      v-model="text"

      api-key="c21xora5cqvlh2qa9snoh4syuep4gwac8piuek5ozs52u839"
      :init="{
         width: '100%',
         skin: 'oxide-dark',
         content_css: 'dark',
        toolbar:
        'undo redo | formatselect | bold italic backcolor | \
        alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | removeformat | help'
      }"
    />
  </div>
</template>

<script>

import Editor from "@tinymce/tinymce-vue"

export default {
  props: ['config', 'content'],
  components: {
    Editor,
  },
  data() {
    return {
      text: this.content && this.content.rich_text || "",
    }
  },
  watch: {
    text() {
      this.$emit("save", this.text)
    },
  },
}

</script>
